import { render, staticRenderFns } from "./WidgetWrapperComponent.vue?vue&type=template&id=aac7af8c&"
import script from "./WidgetWrapperComponent.vue?vue&type=script&lang=js&"
export * from "./WidgetWrapperComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports